module.exports = __webpack_public_path__ + "img/photo-65.73197dd5.webp";